import { Field } from 'formik';
import styled from 'styled-components';

const CheckBoxInlineStyles = styled.div`
  display: inline;

  & label {
    margin-left: 0.5rem;
  }
`

export default function CheckBoxInline({ id, label }) {

  return (
    <CheckBoxInlineStyles>
      <Field
        name={id}
        type='checkbox'
      />

      {label && (
        <label htmlFor={id}>
          {label}
        </label>
      )}

    </CheckBoxInlineStyles>
  )
}